import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function AuthCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Extract token from URL query parameters
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('message');

    if (token) {
      // Save token and redirect to home
      login(token);
      navigate('/');
    } else if (error) {
      // Handle error
      console.error('Authentication error:', error);
      alert(`Authentication failed: ${error}`);
      navigate('/');
    } else {
      // No token or error, redirect to home
      navigate('/');
    }
  }, [login, navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '40px' }}>
      <p>Authenticating...</p>
    </div>
  );
}

export default AuthCallback;
